export default __webpack_public_path__ + "static/media/logosvg.2cfa8a7b.svg";